export const usePDPDetector = () =>
  window.location.pathname.includes('/products/');
